import React from 'react'
import {compose, lifecycle, withState} from 'recompose'
import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css'
import * as media from '../../../../../media'
import styled from 'styled-components'
import ZoomableImage from '../../../../../basic/ZoomableImage'

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(600)`display:none;`}
`
const LessThan1000Check = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  ${media.biggerThan(601)`display:none;`}
`

function Two({list, guid}) {
  return (
    <div className={guid} style={{width: '100%'}}>
      <BiggerThan1000Check className="swiper-container"
                           style={{
                             width: 400,
                             minWidth: 400,
                             maxWidth: 450,
                             textAlign: 'left',
                             background: 'rgb(235,235,235)'
                           }}>
        <div style={{width: 400, minWidth: 400}} className="swiper-wrapper">
          {list.map((element, i) => {
            return (
              <div style={{width: 400, minWidth: 400, ...(i > 0 && {zIndex: -1})}} className="swiper-slide">
                <ZoomableImage
                  src={element}
                  padding={i === 0 ? '25px' : ''}
                  style={{maxHeight: '100%', maxWidth: '100%', padding: 20, ...(i > 0 && {zoom: '1.6', zIndex: -1})}}
                  containerStyle={{
                    paddingTop: 25,
                    paddingBottom: 25,
                    background: 'rgb(235,235,235)',
                    height: 385,
                    width: 400,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 'auto',
                    ...(i > 0 && {zIndex: -1})
                  }}
                />
              </div>
            )
          })}
        </div>
        <div style={{paddingTop: 25, background: 'white'}} className="swiper-pagination-thumb"/>
      </BiggerThan1000Check>
      <LessThan1000Check>
        <ZoomableImage
          src={list[0]}
          style={{ maxHeight: '100%', maxWidth: '100%', padding: 20}}
          padding='25px'
          containerStyle={{
            paddingTop: 25,
            paddingBottom: 25,
            background: 'rgb(235,235,235)',
            width: 320,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
          }}
        />
        <ZoomableImage
          src={list[1]}
          style={{ maxHeight: '100%', maxWidth: '100%', padding: 20}}
          containerStyle={{
            paddingTop: 25,
            paddingBottom: 25,
            background: 'rgb(235,235,235)',
            width: 320,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
          }}
        />
      </LessThan1000Check>
    </div>
  )
}

export default compose(
  withState('guid', 'setGuid', ''),
  lifecycle({
    componentDidMount() {
      function genGuid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }

        return 'x' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }

      const guid = genGuid();
      this.props.setGuid(guid)
      const list = this.props.list
      setTimeout(() => {
        new Swiper(`.${guid} .swiper-container`, {
          loop: true,
          keyboardControl: true,
          autoplay: 6000,
          autoplayDisableOnInteraction: false,
          speed: 1000,
          pagination: {
            el: `.${guid} .swiper-pagination-thumb`,
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '" style="display: inline-block; background: transparent; width: auto; height: auto"><img src="' + list[index] + '" style="max-width:120px; max-height: 160px; margin-right:10px"></span>';
            },
          },
          spaceBetween: 10
        })
      }, 0)
    }
  })
)
(Two)



// WEBPACK FOOTER //
// ./src/finwhale/common/item/image-list/two/index.js